module.exports = __webpack_public_path__ + "static/img/face5.b856131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/face5.png
// module id = Gh57
// module chunks = 1